/* eslint-disable */
import React from 'react';
import { ModalContext } from 'App';
// import Modal from 'modules/common/components/Modal';
import UnitConverter from './UnitConverter';
import ConfirmAlertWithContent from 'modules/common/components/ConfirmAlertWithContent';


const useUnitConverter = (unitOptions, convertTo, onChange) => {
  // const setModal = useContext(ModalContext);

  // const onClose = e => {
  //   e.preventDefault()
  //   setModal({
  //     isOpen: false,
  //   })
  // }

  const show = e => {
    e.preventDefault();
    ConfirmAlertWithContent({
      title: `${unitOptions} converter`,
      content: () => (
        <UnitConverter
          unitOptions={unitOptions} to={convertTo} onChange={onChange}
        />
      ),
    });
  };

  // const show = e => {
  //   e.preventDefault()

  //   setModal({
  //     title: `${unitOptions} converter`,
  //     isOpen: true,
  //     content: <>
  //       <UnitConverter unitOptions={unitOptions} to={convertTo} onChange={onChange} />

  //     </>,
  //     modalSize: 'modal-sm',
  //     hideHeader: false,
  //     isCentered: true,
  //   });
  // }

  const Handler = () => (
    <button title="Unit converter" type="button" className="converter-handle px-0 py-0 mx-0 my-0 float-right" style={{ marginTop: '-4px !important' }} onClick={show}>
      <small className="btn-sm px-0 py-0 mx-0 my-0 text-info text-sm">Convert <i className="fa fa-question-circle " /></small>
    </button>
  )

  return Handler
}

export default useUnitConverter